import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { GENERAL_FONT, MHColours } from '../../constants/theme';

const BackButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const backButtonStyle = {
    borderRadius: '50%',
    backgroundColor: MHColours.mhGreen,
    fontFamily: GENERAL_FONT,
    color: 'white',
    marginRight: '24px',
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Tooltip title={t('back')}>
      <IconButton
        onClick={() => goBack()}
        sx={{ float: 'right' }}
        style={backButtonStyle}
        aria-label="delete"
        size="large"
      >
        <ArrowBackIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
};

export default BackButton;
